// export const API_URL = "http://localhost:9000/api_v2";
export const API_URL =
    window.location.hostname === "www.styldod.com"
        ? "https://api.styldod.com/api_v2"
        : "https://staging-api.styldod.com/api_v2";

export const FORM_SCHEMA = {
    orderID: "",
    project_name: "",
    style: "None",
    number_of_img: 0,
    images_list: [],
    image_details: [],
    links: "",
    comment: "",
    floorplan: [],
    reference_images: [],
    name: "",
    email: "",
    phone: "",
    stype: "staging",
    subscription_id: "",
    add_ons: {
        property_website: "false",
        project_video: "false",
        siteplan: "false",
    },
    isRapidDelivery: "NO",
    isFreeTrial: "NO",
    rapidTime: "NO",
    logs: { order_source: "user_dashboard" },
};

export const ADD_ON_PRICING = {
    basic_editing: 1.5,
    clutter_removal: 8.0,
    occupied_to_vacant: 15.0,
    image_modification: 15.0,
    wall_change: 5.0,
    floor_change: 5.0,
    ceiling_change: 5.0,
    add_fixtures: 8.0,
    bathroom_fit_out: 15.0,
    kitchen_fit_out: 15.0,
    add_deck: 15.0,
    add_pool: 15.0,
    landscaping: 8.0,
    under_construction: 15.0,
    virtual_staging: 23.0,
    property_website: 30.0,
    project_video: 30.0,
    siteplan: 5.0,
    rapid_delivery: 6.0,
    super_rapid_delivery: 12.0,
};

export const SERVICE_PRICING = {
    staging: 23.0,
    commercial_virtual_staging: 24.0,
    virtual_renovation: 0.0,
    image_enhancement: 1.5,
    day_to_dusk: 4.0,
    object_removal: 8.0,
    occupied_to_vacant: 15.0,
    "360_virtual_tour": 1.5,
    "3d_rendered_360_virtual_tour": 250.0,
    single_property_website: 30.0,
    single_property_video: 30.0,
    matterport_virtual_staging: 25.0,
    video_maker: 5.0,
};

export const STYLES = {
    Contemporary: "",
    Farmhouse: "",
    Glam: "",
    Industrial: "",
    Modern: "",
    Scandinavian: "",
    Traditional: "",
    Coastal: "",
};

export const COMMERCIAL_STYLES = {
    Glam: "",
    Industrial: "",
    Modern: "",
};

export const VIRTUAL_RENOVATION_SERVICES = [
    { name: "Wall Color Change", slug: "wall_change" },
    { name: "Floor Change/Replacement", slug: "floor_change" },
    { name: "Ceiling Change", slug: "ceiling_change" },
    { name: "Kitchen Remodel", slug: "kitchen_fit_out" },
    { name: "Bathroom Remodel", slug: "bathroom_fit_out" },
    { name: "Add Pool", slug: "add_pool" },
    { name: "Add Deck", slug: "add_deck" },
    { name: "Landscaping (add plants/foilage)", slug: "landscaping" },
    // { name: 'Finishing under construction spaces', slug: 'under_construction', price: 15 },
    {
        name: "Add Fixtures (doors, windows, fireplace, light fixtures)",
        slug: "add_fixtures",
    },
];

export const FLOORPLAN_STYLES = {
    "2DBFP": {
        img: "https://uploads-ssl.webflow.com/5dcf94bbedfe6a0469634ea8/600838afb1ce4c0e07f68ad6_2DBasic-After.jpg",
        price: 9.0,
        name: "2D Basic FP",
    },
    "2DBFPF": {
        img: "https://uploads-ssl.webflow.com/5dcf94bbedfe6a0469634ea8/600838af17cc8d57e5c56a80_2DBasicwithFurniture-After.jpg",
        price: 14.0,
        name: "2D Basic FP furniture",
    },
    "2DCFP": {
        img: "https://uploads-ssl.webflow.com/5dcf94bbedfe6a0469634ea8/6008394ec54963cd840a9508_2DStandard-After.jpg",
        price: 12.0,
        name: "2D Color FP",
    },
    "2DCFPF": {
        img: "https://uploads-ssl.webflow.com/5dcf94bbedfe6a0469634ea8/600839519513659a369a8044_2DStandardwithFurniture-After.jpg",
        price: 16.0,
        name: "2D Color FP furniture",
    },
    "3DBFP": {
        img: "https://uploads-ssl.webflow.com/5dcf94bbedfe6a0469634ea8/600839a47bf43ecb087c8c0e_3DBasic-After.jpg",
        price: 19.0,
        name: "3D Basic FP",
    },
    "3DCFP": {
        img: "https://uploads-ssl.webflow.com/5dcf94bbedfe6a0469634ea8/600839a54553ec206f6c94b8_3DStandard-After.jpg",
        price: 24.0,
        name: "3D Color FP",
    },
};

let vid_url = "https://cdn.styldod.com/videos/";
let thumb_url =
    "https://cdn.styldod.com/video_after_delivery/shotstack/thumbnail/";

export const JUST_LISTED_TEMPLATES = [
    {
        id: "07",
        link: `${vid_url}just_listed/just_listed_7_v2.mp4`,
        thumbnail: `${thumb_url}just_listed_template_2_9_16_v2.jpg`,
        name: "Vibrant Orange (Mobile)",
        desc: "Create a bold and attention-grabbing visual aesthetic with this video template.",
        noOfImagesRequired: 5,
        noOfMaxImagesRequired: 10,
        form_id: 1,
        function_id: "9",
        deviceType: "mobile",
    },
    {
        id: "05",
        link: `${vid_url}just_listed/just_listed_5.mp4`,
        thumbnail: `${thumb_url}just_listed_beetleBlue_9_16_v2.jpg`,
        name: "Classic Grey (Mobile)",
        desc: "The perfect way to show off your home's beauty on social media with this video template.",
        noOfImagesRequired: 5,
        noOfMaxImagesRequired: 10,
        form_id: 1,
        function_id: "4",
        deviceType: "mobile",
    },
    {
        id: "08",
        link: `${vid_url}just_listed/just_listed_8_v2.mp4`,
        thumbnail: `${thumb_url}just_listed_8.jpg`,
        name: "Green Fields (Mobile)",
        desc: "With this mobile-friendly template, announce your freshly listed property to the world.",
        noOfImagesRequired: 5,
        noOfMaxImagesRequired: 10,
        form_id: 5,
        function_id: "12",
        deviceType: "mobile",
    },
    {
        id: "09",
        link: `${vid_url}just_listed/just_listed_9_v2.mp4`,
        thumbnail: `${thumb_url}just_listed_9.jpg`,
        name: "Blue Ocean (Mobile)",
        desc: "Like the deep blue ocean, this template exudes endless possibilities.",
        noOfImagesRequired: 5,
        noOfMaxImagesRequired: 10,
        form_id: 5,
        function_id: "12",
        deviceType: "mobile",
    },
    {
        id: "010",
        link: `${vid_url}just_listed/just_listed_10_v2.mp4`,
        thumbnail: `${thumb_url}just_listed_10.jpg`,
        name: "Down to Earth (Mobile)",
        desc: "A template to illustrate the beauty of your property during the golden hour.",
        noOfImagesRequired: 5,
        noOfMaxImagesRequired: 10,
        form_id: 5,
        function_id: "12",
        deviceType: "mobile",
    },
    {
        id: "06",
        link: `${vid_url}just_listed/just_listed_6_v2.mp4`,
        thumbnail: `${thumb_url}just_listed_template_2_v2.jpg`,
        name: "Vibrant Orange",
        desc: "Drive energy and excitement in the market for your just listed property.",
        noOfImagesRequired: 5,
        noOfMaxImagesRequired: 10,
        form_id: 1,
        function_id: "8",
        deviceType: "desktop",
    },
    {
        id: "04",
        link: `${vid_url}just_listed/just_listed_4.mp4`,
        thumbnail: `${thumb_url}just_listed_beetleBlue_v2.jpg`,
        name: "Classic Grey",
        desc: "Classic video template to simply present your listing's best home tour.",
        noOfImagesRequired: 5,
        noOfMaxImagesRequired: 10,
        form_id: 1,
        function_id: "3",
        deviceType: "desktop",
    },
    {
        id: "01",
        link: `${vid_url}just_listed/just_listed_1.mp4`,
        thumbnail: `${thumb_url}just_listed_green.png`,
        name: "Green Fields",
        desc: "An attractive template that can infuse life into your listing video.",
        noOfImagesRequired: 5,
        noOfMaxImagesRequired: 10,
        form_id: 5,
        function_id: "1",
        deviceType: "desktop",
    },
    {
        id: "02",
        link: `${vid_url}just_listed/just_listed_2.mp4`,
        thumbnail: `${thumb_url}just_listed_blue.png`,
        name: "Blue Ocean",
        desc: "The sky's the limit for this beautiful just listed video template.",
        noOfImagesRequired: 5,
        noOfMaxImagesRequired: 10,
        form_id: 5,
        function_id: "1",
        deviceType: "desktop",
    },
    {
        id: "03",
        link: `${vid_url}just_listed/just_listed_3.mp4`,
        thumbnail: `${thumb_url}just_listed_red.png`,
        name: "Down to Earth",
        desc: "Convey the warmth of a home with this creative just listed video template.",
        noOfImagesRequired: 5,
        noOfMaxImagesRequired: 10,
        form_id: 5,
        function_id: "1",
        deviceType: "desktop",
    },
];

export const JUST_SOLD_TEMPLATES = [
    {
        id: "17",
        link: `${vid_url}just_sold/just_sold_7.mp4`,
        thumbnail: `${thumb_url}just_sold_template_2_9_16.jpg`,
        name: "Vibrant Orange (Mobile)",
        desc: "With a vibrant theme, this video is the perfect way to promote your expertise and attract clients.",
        noOfImagesRequired: 5,
        noOfMaxImagesRequired: 10,
        form_id: 1,
        function_id: "9",
        deviceType: "mobile",
    },
    {
        id: "15",
        link: `${vid_url}just_sold/just_sold_5.mp4`,
        thumbnail: `${thumb_url}just_sold_beetleBlue_9_16_v2.jpg`,
        name: "Grey Stone (Mobile)",
        desc: "Just Sold a house? Update your social network with a quick mobile video!",
        noOfImagesRequired: 5,
        noOfMaxImagesRequired: 10,
        form_id: 1,
        function_id: "4",
        deviceType: "mobile",
    },
    {
        id: "18",
        link: `${vid_url}just_sold/just_sold_8.mp4`,
        thumbnail: `${thumb_url}just_sold_orange_9_16.jpg`,
        name: "Orange City (Mobile)",
        desc: "Improve the user experience with this responsive template to inspire trust and credibility.",
        noOfImagesRequired: 5,
        noOfMaxImagesRequired: 10,
        form_id: 5,
        function_id: "13",
        deviceType: "mobile",
    },
    {
        id: "19",
        link: `${vid_url}just_sold/just_sold_9.mp4`,
        thumbnail: `${thumb_url}just_sold_blue_9_16.jpg`,
        name: "Blue Horizon (Mobile)",
        desc: "This template captivates with its beauty and depth, much like the deep blue ocean.",
        noOfImagesRequired: 5,
        noOfMaxImagesRequired: 10,
        form_id: 5,
        function_id: "13",
        deviceType: "mobile",
    },
    {
        id: "110",
        link: `${vid_url}just_sold/just_sold_10.mp4`,
        thumbnail: `${thumb_url}just_sold_green_9_16.jpg`,
        name: "Green Globe (Mobile)",
        desc: "An eye-catching green model to share your accomplishment with the world.",
        noOfImagesRequired: 5,
        noOfMaxImagesRequired: 10,
        form_id: 5,
        function_id: "13",
        deviceType: "mobile",
    },
    {
        id: "16",
        link: `${vid_url}just_sold/just_sold_6.mp4`,
        thumbnail: `${thumb_url}just_sold_template_2.jpg`,
        name: "Vibrant Orange",
        desc: "Make a statement with your recently sold property with this vibrant orange that just sold!",
        noOfImagesRequired: 5,
        noOfMaxImagesRequired: 10,
        form_id: 1,
        function_id: "8",
        deviceType: "desktop",
    },
    {
        id: "14",
        link: `${vid_url}just_sold/just_sold_4.mp4`,
        thumbnail: `${thumb_url}just_sold_beetleBlue_v2.jpg`,
        name: "Grey Stone",
        desc: `An agent's favorite milestone: when you get to post the "Just Sold" sign on a house!`,
        noOfImagesRequired: 5,
        noOfMaxImagesRequired: 10,
        form_id: 1,
        function_id: "3",
        deviceType: "desktop",
    },
    {
        id: "11",
        link: `${vid_url}just_sold/just_sold_1.mp4`,
        thumbnail: `${thumb_url}just_sold_orange.png`,
        name: "Orange City",
        desc: "Invoke trust with this just sold template that shows you mean business.",
        noOfImagesRequired: 5,
        noOfMaxImagesRequired: 10,
        form_id: 5,
        function_id: "2",
        deviceType: "desktop",
    },
    {
        id: "12",
        link: `${vid_url}just_sold/just_sold_2.mp4`,
        thumbnail: `${thumb_url}just_sold_blue.png`,
        name: "Blue Horizon",
        desc: "Mesmerizing like the deep blue ocean this template oozes professionalism.",
        noOfImagesRequired: 5,
        noOfMaxImagesRequired: 10,
        form_id: 5,
        function_id: "2",
        deviceType: "desktop",
    },
    {
        id: "13",
        link: `${vid_url}just_sold/just_sold_3.mp4`,
        thumbnail: `${thumb_url}just_sold_green.png`,
        name: "Green Globe",
        desc: "A vibrant green template to showcase your recent achievement.",
        noOfImagesRequired: 5,
        noOfMaxImagesRequired: 10,
        form_id: 5,
        function_id: "2",
        deviceType: "desktop",
    },
];

export const PERSONAL_BRANDING_TEMPLATES = [
    {
        id: "21",
        link: "https://cdn.styldod.com/video_after_delivery/shotstack/videos/pb_render.mp4",
        name: "Personal Branding - Basic Template",
        desc: "",
        noOfImagesRequired: 4,
    },
    {
        id: "22",
        link: "https://cdn.styldod.com/video_after_delivery/shotstack/videos/pb_render.mp4",
        name: "Personal Branding - Basic Template 2",
        desc: "",
        noOfImagesRequired: 4,
    },
];

export const OPEN_HOUSE_TEMPLATES = [
    {
        id: "33",
        link: `${vid_url}open_house/open_house_3.mp4`,
        thumbnail: `${thumb_url}open_house_3.jpg`,
        name: "Globe Grey (Mobile)",
        desc: "Open your listing to the world with this magnificent template.",
        noOfImagesRequired: 5,
        noOfMaxImagesRequired: 10,
        form_id: 2,
        function_id: "11",
        deviceType: "mobile",
    },
    {
        id: "31",
        link: `${vid_url}open_house/open_house_1_v2.mp4`,
        thumbnail: `${thumb_url}open_house_ginger_lily_9_16.jpg`,
        name: "Forest Green (Mobile)",
        desc: "Invite potential buyers with natural forestry look of your elegant listing.",
        noOfImagesRequired: 5,
        noOfMaxImagesRequired: 10,
        form_id: 2,
        function_id: "6",
        deviceType: "mobile",
    },
    {
        id: "34",
        link: `${vid_url}open_house/open_house_4.mp4`,
        thumbnail: `${thumb_url}open_house_4.jpg`,
        name: "Globe Grey",
        desc: "Allure the buyer with the grey tone of your classy listing",
        noOfImagesRequired: 5,
        noOfMaxImagesRequired: 10,
        form_id: 2,
        function_id: "10",
        deviceType: "desktop",
    },
    {
        id: "32",
        link: `${vid_url}open_house/open_house_2_v2.mp4`,
        thumbnail: `${thumb_url}open_house_ginger_lily.jpg`,
        name: "Forest Green",
        desc: "Give your listing the royal touch with forestry look video template.",
        noOfImagesRequired: 5,
        noOfMaxImagesRequired: 10,
        form_id: 2,
        function_id: "5",
        deviceType: "desktop",
    },
    {
        id: "35",
        link: `${vid_url}open_house/open_house_5.mp4`,
        thumbnail: `${thumb_url}open_house_5.jpg`,
        name: "Bold Blue (Mobile)",
        desc: "Seize attention using Bold Blue, making your listings gleam with confidence and influence.",
        noOfImagesRequired: 5,
        noOfMaxImagesRequired: 10,
        form_id: 2,
        function_id: "15",
        deviceType: "mobile",
    },
    {
        id: "36",
        link: `${vid_url}open_house/open_house_6.mp4`,
        thumbnail: `${thumb_url}open_house_6.jpg`,
        name: "Bold Blue",
        desc: "Unleash the power of striking blues designed to make your listings stand out with confidence.",
        noOfImagesRequired: 5,
        noOfMaxImagesRequired: 10,
        form_id: 2,
        function_id: "16",
        deviceType: "desktop",
    },
    {
        id: "37",
        link: `${vid_url}open_house/open_house_7.mp4`,
        thumbnail: `${thumb_url}open_house_7.jpg`,
        name: "Clear Cyan (Mobile)",
        desc: "Embrace the essence of clarity designed to make your listings sparkle and captivate.",
        noOfImagesRequired: 5,
        noOfMaxImagesRequired: 10,
        form_id: 2,
        function_id: "24",
        deviceType: "mobile",
    },
    {
        id: "38",
        link: `${vid_url}open_house/open_house_8.mp4`,
        thumbnail: `${thumb_url}open_house_8.jpg`,
        name: "Clear Cyan",
        desc: "Immerse in Clear Cyan's refreshing realm, enhancing listings with striking, vibrant clarity.",
        noOfImagesRequired: 5,
        noOfMaxImagesRequired: 10,
        form_id: 2,
        function_id: "17",
        deviceType: "desktop",
    },
    {
        id: "39",
        link: `${vid_url}open_house/open_house_9.mp4`,
        thumbnail: `${thumb_url}open_house_9.jpg`,
        name: "Silvery Peach (Mobile)",
        desc: "Relish Silvery Peach's subtle elegance and charm, elevating listings with refined grace.",
        noOfImagesRequired: 5,
        noOfMaxImagesRequired: 10,
        form_id: 2,
        function_id: "25",
        deviceType: "mobile",
    },
    {
        id: "310",
        link: `${vid_url}open_house/open_house_10.mp4`,
        thumbnail: `${thumb_url}open_house_10.jpg`,
        name: "Silvery Peach",
        desc: "Boost listings with Silver Peach's refined charm, fusing sophistication and subtle grace.",
        noOfImagesRequired: 5,
        noOfMaxImagesRequired: 10,
        form_id: 2,
        function_id: "18",
        deviceType: "desktop",
    },
    {
        id: "311",
        link: `${vid_url}open_house/open_house_11.mp4`,
        thumbnail: `${thumb_url}open_house_11.jpg`,
        name: "Gracious Green (Mobile)",
        desc: "Experience the soothing allure, designed to enliven your listings with its tranquil charm.",
        noOfImagesRequired: 5,
        noOfMaxImagesRequired: 10,
        form_id: 2,
        function_id: "26",
        deviceType: "mobile",
    },
    {
        id: "312",
        link: `${vid_url}open_house/open_house_12.mp4`,
        thumbnail: `${thumb_url}open_house_12.jpg`,
        name: "Gracious Green",
        desc: "Immerse your listings in the serene harmony where natural hues inspire and enchant.",
        noOfImagesRequired: 5,
        noOfMaxImagesRequired: 10,
        form_id: 2,
        function_id: "19",
        deviceType: "desktop",
    },
];

export const CLIENT_TESTIMONIAL_TEMPLATES = [
    {
        id: "41",
        link: `${vid_url}client_testimonial/client_testimonial_1.mp4`,
        thumbnail: `${thumb_url}client_testimonial_blue_9_16.jpg`,
        name: "Connecting Blue (Mobile)",
        desc: "Share the social proof of trust and credibility with 'Connecting Blue' testimonial template.",
        noOfImagesRequired: 4,
        noOfMaxImagesRequired: 4,
        form_id: 3,
        function_id: "7",
        deviceType: "mobile",
    },
    {
        id: "42",
        link: `${vid_url}client_testimonial/client_testimonial_2.mp4`,
        thumbnail: `${thumb_url}client_testimonial_blue.jpg`,
        name: "Connecting Blue",
        desc: "Try this template to connect with potential customers with a strong business reputation.",
        noOfImagesRequired: 4,
        noOfMaxImagesRequired: 4,
        form_id: 4,
        function_id: "7",
        deviceType: "desktop",
    },
    {
        id: "44",
        link: `${vid_url}client_testimonial/client_testimonial_2_9_16.mp4`,
        thumbnail: `${thumb_url}client_testimonial_2_9_16.jpg`,
        name: "Smoky Grey (Mobile)",
        desc: "Embody modern sophistication, enhancing listings with a sleek, minimalist flair.",
        noOfImagesRequired: 3,
        noOfMaxImagesRequired: 3,
        form_id: 7,
        function_id: "14",
        deviceType: "mobile",
    },
    {
        id: "43",
        link: `${vid_url}client_testimonial/client_testimonial_3.mp4`,
        thumbnail: `${thumb_url}client_testimonial_2.jpg`,
        name: "Smoky Grey",
        desc: "Smoky Grey template adds depth & allure, elevating content with muted tones' mystique.",
        noOfImagesRequired: 3,
        noOfMaxImagesRequired: 3,
        form_id: 7,
        function_id: "14",
        deviceType: "desktop",
    },
    {
        id: "45",
        link: `${vid_url}client_testimonial/client_testimonial_3_9_16.mp4`,
        thumbnail: `${thumb_url}client_testimonial_3_9_16.jpg`,
        name: "Deep Aquamarine (Mobile)",
        desc: "Explore oceanic depths, where listings flourish with captivating, undersea charm.",
        noOfImagesRequired: 3,
        noOfMaxImagesRequired: 3,
        form_id: 7,
        function_id: "20",
        deviceType: "mobile",
    },
    {
        id: "46",
        link: `${vid_url}client_testimonial/client_testimonial_3_new.mp4`,
        thumbnail: `${thumb_url}client_testimonial_3.jpg`,
        name: "Deep Aquamarine",
        desc: "Explore ocean depths with mesmerizing hues that elevate listings to intriguing new heights.",
        noOfImagesRequired: 3,
        noOfMaxImagesRequired: 3,
        form_id: 7,
        function_id: "20",
        deviceType: "desktop",
    },
    {
        id: "47",
        link: `${vid_url}client_testimonial/client_testimonial_4_9_16.mp4`,
        thumbnail: `${thumb_url}client_testimonial_4_9_16.jpg`,
        name: "Fresh Lavender (Mobile)",
        desc: "Lavender's delicate charm enhances listings, captivating with its soothing, floral hues.",
        noOfImagesRequired: 3,
        noOfMaxImagesRequired: 3,
        form_id: 7,
        function_id: "21",
        deviceType: "mobile",
    },
    {
        id: "48",
        link: `${vid_url}client_testimonial/client_testimonial_4.mp4`,
        thumbnail: `${thumb_url}client_testimonial_4.jpg`,
        name: "Fresh Lavender",
        desc: "List with Lavender's soothing charm, merging gentle purples for tranquility and innovation.",
        noOfImagesRequired: 3,
        noOfMaxImagesRequired: 3,
        form_id: 7,
        function_id: "21",
        deviceType: "desktop",
    },
    {
        id: "49",
        link: `${vid_url}client_testimonial/client_testimonial_5_9_16.mp4`,
        thumbnail: `${thumb_url}client_testimonial_5_9_16.jpg`,
        name: "Blazing Tangerine (Mobile)",
        desc: "Ignite listings with Blazing Tangerine, expertly crafted to captivate and inspire enthusiasm.",
        noOfImagesRequired: 3,
        noOfMaxImagesRequired: 3,
        form_id: 7,
        function_id: "22",
        deviceType: "mobile",
    },
    {
        id: "410",
        link: `${vid_url}client_testimonial/client_testimonial_5.mp4`,
        thumbnail: `${thumb_url}client_testimonial_5.jpg`,
        name: "Blazing Tangerine",
        desc: "Blazing Tangerine ignites listings with fiery hues, inspiring with vibrant flair.",
        noOfImagesRequired: 3,
        noOfMaxImagesRequired: 3,
        form_id: 7,
        function_id: "22",
        deviceType: "desktop",
    },
    {
        id: "411",
        link: `${vid_url}client_testimonial/client_testimonial_6_9_16.mp4`,
        thumbnail: `${thumb_url}client_testimonial_6_9_16.jpg`,
        name: "Glowing Gradient (Mobile)",
        desc: "Boost listings using Glowing Gradient template, captivating with seamless color transitions.",
        noOfImagesRequired: 3,
        noOfMaxImagesRequired: 3,
        form_id: 7,
        function_id: "23",
        deviceType: "mobile",
    },
    {
        id: "412",
        link: `${vid_url}client_testimonial/client_testimonial_6.mp4`,
        thumbnail: `${thumb_url}client_testimonial_6.jpg`,
        name: "Glowing Gradient",
        desc: "Enliven listings with Glowing Gradient's vivid, shifting hues, crafted to captivate and impress.",
        noOfImagesRequired: 3,
        noOfMaxImagesRequired: 3,
        form_id: 7,
        function_id: "23",
        deviceType: "desktop",
    },
];
export const SOLD_OVER_ASKING_PRICE_TEMPLATES = [
    {
        id: "51",
        link: "https://cdn.styldod.com/videos/sold_over_asking_price/sold_over_asking_price_1_v2.mp4",
        thumbnail:
            "https://cdn.styldod.com/video_after_delivery/shotstack/thumbnail/sold_over_asking_price_1_v2.jpg",
        name: "Sold Over Asking (Mobile)",
        desc: "Keep your network warm by sharing a video of you selling a property over the asking price.",
        noOfImagesRequired: 2,
        noOfMaxImagesRequired: 2,
        form_id: 6,
    },
    {
        id: "52",
        link: "https://cdn.styldod.com/videos/sold_over_asking_price/sold_over_asking_price_2_v2.mp4",
        thumbnail:
            "https://cdn.styldod.com/video_after_delivery/shotstack/thumbnail/sold_over_asking_price_2_v2.jpg",
        name: "Sold Over Asking",
        desc: "Create video for your professional accomplishment with this template.",
        noOfImagesRequired: 2,
        noOfMaxImagesRequired: 2,
        form_id: 6,
    },
];

export const VIDEO_EDITING_PRICING = {
    PVE: 80.0,
    DVE: 60.0,
    CLIP: 60.0,
};

export const SERVICE_TYPE_NAMES = {
    staging: "Virtual Staging",
    commercial_virtual_staging: "Commercial Virtual Staging",
    matterport_virtual_staging: "Matterport Virtual Staging",
    virtual_renovation: "Virtual Renovation",
    object_removal: "Object Removal",
    occupied_to_vacant: "Occupied to Vacant",
    "3d_rendered_360_virtual_tour": "3D Rendering",
    floorplan: "Floorplan",
    "360_virtual_tour": "360° Virtual tours",
    single_property_website: "Single Property Website",
    single_property_video: "Single Property Video",
    image_enhancement: "Image Enhancement",
    day_to_dusk: "Day to Dusk",
    video_editing: "Video Editing",
    video_maker: "Video Maker",
};

export const PROCESS_INDICATOR = {
    styles: "Pick a design style for your property",
    upldImg: "Upload photos of your property",
    imgDtls: "Add details about your property photos",
};

export const SPWSTYLES = [
    {
        name: "Cabana",
        url: "https://property-websites.webflow.io/cabana-template",
        value: "cabana",
    },
    {
        name: "Flexport",
        url: "https://property-websites.webflow.io/flexport",
        value: "flexport",
    },
    {
        name: "Portofino",
        url: "https://property-websites.webflow.io/portofino-template",
        value: "portofino",
    },
];
